import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { MatMenuPanel } from '@angular/material/menu';
import { Router } from '@angular/router';
import { MenuOption } from '@app/core/models/menu-option.model';

@Component({
  selector: 'dhl-menu-horizontal-item',
  templateUrl: './menu-horizontal-item.component.html',
  styleUrls: ['./menu-horizontal-item.component.scss']
})
export class MenuHorizontalItemComponent {
  @Input() options: MenuOption[] = [];
  @Output() closeSidenav = new EventEmitter<void>();
  @ViewChild('subMenu', { static: true }) public subMenu!: MatMenuPanel<unknown>;

  constructor(public router: Router) {}

  isChildRouteActive(submenu: MenuOption[]): boolean {
    return submenu.some((e) => e.url === this.router.routerState.snapshot.url);
  }

  isCurrentUrl(menuOption: MenuOption): boolean {
    return menuOption.url === this.router.routerState.snapshot.url;
  }
}
